/**
 * @name results.controller:directiveMeetingStaff
 * @description
 * # directiveMeetingStaff controller
 * Controller for meetingStaff directive. Should keep any methods, that related to meeting container
 */
export default function ($scope, $element) {
    'ngInject';

    /**
     * Name of event which directive should listen
     * @type {string}
     */
    $scope.event = `showMeetingContainer[${$scope.courseId}]`;

    /*
     * Init listener for appropriate event
     */
    $scope.init = () => {
        $scope.$on($scope.event, () => {
            $element.removeClass($scope.emptySelector);
        });
    };

    $scope.init();
}



// WEBPACK FOOTER //
// ./src/js/controllers/directiveMeetingStaff.js